// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falAnglesLeft: CreateIconOptions = {
  "displayName": "FALAnglesLeft",
  "viewBox": "0, 0, 512, 512",
  "d": "M68.1 245.3c-5.5 6.1-5.5 15.3 0 21.4l144 160c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6L101.5 256 235.9 106.7c5.9-6.6 5.4-16.7-1.2-22.6s-16.7-5.4-22.6 1.2l-144 160zm336-160l-144 160c-5.5 6.1-5.5 15.3 0 21.4l144 160c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6L293.5 256 427.9 106.7c5.9-6.6 5.4-16.7-1.2-22.6s-16.7-5.4-22.6 1.2z"
};
